import { getIn } from 'formik';

export default function isRequiredField(name, schemaToValidation) {
  const result = getIn(schemaToValidation.describe().fields, name);

  return result
    ? result.tests.find(test => test && test.name === 'required')
    : false;
}
